var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.data.asset_status !== this.$t('count.not_reg'))?_c('div',{staticClass:"bin-icon",on:{"click":_vm.goToDetail}},[_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":require("@/assets/edit_pencil.svg")}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }